'use client'

import React, { useEffect, useRef, useState } from 'react'
import Box from '../../components/UI/Box'
import WidgetPreview from '@enhanci/enhanci-lib'
import '@enhanci/enhanci-lib/styles.css'

const WidgetPreviewPage = () => {
  const [widget, setWidget] = useState(null)
  const ref = useRef<HTMLDivElement | null>(null)
  const lib = useRef<{ destroy: () => void } | null>(null)

  const onEventListener = event => {
    if (event.data.type === 'widgetUpdate') {
      setWidget(event.data.payload)
    }
  }

  const onDocumentClickHandler = e => {
    if (e.target?.tagName === 'A') {
      e.stopPropagation()
      e.preventDefault()
    }
  }

  useEffect(() => {
    window.parent.postMessage({ type: 'ready' }, '*')

    window.addEventListener('message', onEventListener, false)

    document.addEventListener('click', onDocumentClickHandler)

    return () => {
      window.removeEventListener('message', onEventListener, false)
      document.removeEventListener('click', onDocumentClickHandler)
    }
  }, [])

  useEffect(() => {
    if (ref.current && widget) {
      lib.current = new WidgetPreview(ref.current, widget)
    }

    return () => {
      lib.current?.destroy()
    }
  }, [ref.current, widget])
  return (
    <Box p={16}>
      <div ref={ref} />
    </Box>
  )
}

export default WidgetPreviewPage
